export const workSnColumn = [
  {
    title: '工单号',
    key: 'work_sn',
    type: 'number',
    width: 200,
    height: 50,
  },
  {
    title: '账号',
    key: 'account',
    type: 'text',
  },
  {
    title: '游戏名',
    key: 'game_name',
    type: 'text',
  },
  {
    title: '区服',
    key: 'server',
    type: 'text',
  },
  {
    title: '角色名',
    key: 'game_role_name',
    type: 'text',
  },
  {
    title: '详情',
    key: 'details',
    type: 'text',
  },
  {
    title: '处理人',
    key: 'deal_user_name',
    type: 'text',
  },
  {
    title: '回复内容',
    key: 'reply',
    type: 'text',
  },
  {
    title: '图片',
    key: 'images',
    type: 'images',
    width: 120,
    height: 300,
  },
];
